<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         class="ui-alerts-page-grid">
    <ui-grid-row-config [ngClassFn]="classConfig">
    </ui-grid-row-config>

    <ui-grid-header [search]="true">
        <ui-header-button type="action">
            <ng-template>
                <button (click)="markAsRead()"
                        [disabled]="!allowMarkAsRead"
                        [matTooltip]="'alerts_grid_action_mark_all_read' | translate"
                        mat-icon-button
                        type="button">
                    <mat-icon>done</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [visible]="false"
                    [searchable]="true"
                    property="data">
    </ui-grid-column>

    <ui-grid-column [title]="'alerts_grid_severity' | translate"
                    [sortable]="true"
                    property="severity"
                    width="15%">
        <ui-grid-dropdown-filter [items]="severityList"
                                 [value]="defaultSeverity"
                                 [showAllOption]="false"
                                 method="ge">
        </ui-grid-dropdown-filter>
        <ng-template let-index="index"
                     let-entry="data">
            <ng-container *ngLet="('SeverityType_' + entry.severity | translate) as severityText">
                <span [matTooltip]="severityText">
                    {{ severityText }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [title]="'alerts_grid_component' | translate"
                    [sortable]="false"
                    [searchable]="false"
                    property="component"
                    width="15%">
        <ui-grid-dropdown-filter [items]="componentsMap"
                                 method="eq">
        </ui-grid-dropdown-filter>
        <ng-template let-index="index"
                     let-entry="data">
            <ng-container *ngLet="('ComponentType_' + entry.component | translate) as componentText">
                <ng-container [ngSwitch]="entry.component">
                    <mat-icon *ngSwitchCase="'Robots'"
                              svgIcon="uipath:robots"></mat-icon>
                    <mat-icon *ngSwitchCase="'Transactions'"
                              svgIcon="uipath:queues"></mat-icon>
                    <mat-icon *ngSwitchCase="'Triggers'"
                              svgIcon="uipath:triggers"></mat-icon>
                    <mat-icon *ngSwitchCase="'Jobs'"
                              svgIcon="uipath:jobs"></mat-icon>
                    <mat-icon *ngSwitchCase="'Process'">swap_horiz</mat-icon>
                    <mat-icon *ngSwitchCase="'Queues'"
                              svgIcon="uipath:queues">
                    </mat-icon>
                </ng-container>
                <span [matTooltip]="componentText">{{ componentText }}</span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [title]="'alerts_grid_notification' | translate"
                    [sortable]="false"
                    [searchable]="false"
                    width="50%"
                    property="data.message">
    </ui-grid-column>
    <ui-grid-column [title]="'alerts_grid_time' | translate"
                    [sortable]="true"
                    [searchable]="false"
                    property="timestamp"
                    sort="desc"
                    width="20%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #timeStampFormat
                           [matTooltip]="timeStampFormat?.dataset['title']"
                           [date]="entry.timestamp"
                           contentType="relative"></ui-dateformat>
        </ng-template>
        <ui-grid-dropdown-filter [items]="intervals"
                                 [value]="intervalValueFor(Interval.Day)"
                                 method="ge">
        </ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-column [title]="'alerts_grid_state' | translate"
                    [visible]="false"
                    [searchable]="false"
                    property="state">
        <ui-grid-dropdown-filter [items]="stateList"
                                 [value]="defaultState"
                                 [showAllOption]="true"
                                 method="eq">
        </ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <ng-container *ngIf="entry.showDetails">
                <button *ngLet="entry.data?.folderId && entry.data?.folderId !== currentFolderId as isDifferentFolder"
                        [uiAuthorizeAllDisable]="entry.permissions"
                        [disableIf]="isDifferentFolder"
                        [title]="isDifferentFolder ? ('alerts_grid_action_different_folder' | translate: { fqn: entry.data?.folderFullyQualifiedName }) : null"
                        [matTooltip]="'alerts_grid_action_show_details' | translate"
                        (click)="showDetails(entry)"
                        mat-icon-button
                        matTooltipPosition="left"
                        type="button">
                    <mat-icon svgIcon="uipath:info"></mat-icon>
                </button>
            </ng-container>
            <button [matTooltip]="'alerts_grid_action_mark_read' | translate"
                    [disabled]="entry.state === 'Read'"
                    [uiClickTrack]="'Action: Grid: Mark As Read'"
                    (click)="markAsRead([entry])"
                    mat-icon-button
                    matTooltipPosition="left"
                    type="button">
                <mat-icon>done</mat-icon>
            </button>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
